import { TEMP_AUTH_TOKEN_LOYALTY } from '../constants';
import {
  CONFIRM_APPOINTMENT_URL,
  FEEDBACK_APPOINTMENT_URL,
  GET_APPOINTMENT_DETAILS_URL,
} from '../utils/environment';
import { AppointmentResponse } from '../types/appointment';
import axiosInstance from '../utils/axiosInstance';

class AppointmentServices {
  static async getAppointmentDetails(appointmentID: string): Promise<AppointmentResponse | null> {
    try {
      if (!appointmentID) {
        throw new Error('appointmentID is required');
      }
      const res = await axiosInstance.post<{ Status: boolean; data: AppointmentResponse }>(
        GET_APPOINTMENT_DETAILS_URL,
        {
          encrpt: appointmentID,
        },
        {
          headers: {
            'auth-token': TEMP_AUTH_TOKEN_LOYALTY,
            'Content-Type': 'application/json',
          },
        },
      );

      const data = res?.data;

      if (data?.Status && data?.data) {
        return data?.data;
      }

      return null;
    } catch (error) {
      console.log('Error in getAppointmentDetails: ', error);
      return null;
    }
  }

  static async confirmAppointment(
    ticket_id: string,
    mobile: string | number,
    appointment_date: string,
    appointment_slot: '01' | '02' | '03',
    isConfirm?: boolean,
    hasTechCalled?: boolean,
  ): Promise<boolean> {
    try {
      if (!ticket_id) {
        throw new Error('ticket_id is required');
      }

      if (!mobile) {
        throw new Error('mobile is required');
      }

      if (!appointment_date) {
        throw new Error('appointment_date is required');
      }

      if (!appointment_slot) {
        throw new Error('appointment_slot is required');
      }

      const data = {
        ticket_id,
        appt_reason: !!isConfirm ? 'Y' : 'N',
        updated_by: 'Customer',
        mobile,
        appointment_date,
        appointment_slot,
        isTechCalled: !!hasTechCalled ? 1 : 0,
      };

      const res = await axiosInstance.post(CONFIRM_APPOINTMENT_URL, data, {
        headers: {
          'auth-token': TEMP_AUTH_TOKEN_LOYALTY,
          'Content-Type': 'application/json',
        },
      });

      if (!res?.data) {
        throw new Error('No response from server');
      }

      if (res?.data?.Status === undefined) {
        throw new Error('Invalid response from server');
      }

      return res?.data?.Status;
    } catch (error) {
      console.log('Error in confirmAppointment: ', error);
      return false;
    }
  }

  static async feedbackAppointment(
    ticket_id: string,
    response: string,
    visit_reason: string,
  ): Promise<boolean> {
    try {
      if (!ticket_id) {
        throw new Error('ticket_id is required');
      }

      if (!response) {
        throw new Error('response is required');
      }

      if (!visit_reason) {
        throw new Error('visit_reason is required');
      }

      const data = {
        ticket_id,
        response,
        reason: visit_reason,
      };

      const res = await axiosInstance.post(FEEDBACK_APPOINTMENT_URL, data, {
        headers: {
          'auth-token': TEMP_AUTH_TOKEN_LOYALTY,
          'Content-Type': 'application/json',
        },
      });

      if (!res) {
        throw new Error('No response from server');
      }

      if (!res.data || !res.data.status) {
        throw new Error('Invalid response from server');
      }

      return res.data.status;
    } catch (error) {
      console.log('Error in feedbackAppointment: ', error);
      return false;
    }
  }
}

export default AppointmentServices;
